import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 新增敏感词：
export const addSensitiveApi = (data) => {
  return httpService({
    url: contextPath + '/spider/sensitive/word/item',
    method: 'post',
    data
  })
}

// 修改敏感词：
export const editSensitiveApi = (data) => {
  return httpService({
    url: contextPath + '/spider/sensitive/word/item',
    method: 'put',
    data
  })
}

// 删除敏感词：
export const deleteSensitiveApi = (params) => {
  return httpService({
    url: contextPath + `/spider/sensitive/word/${params}`,
    method: 'delete'
  })
}

// 敏感词列表查询：
export const getSensitiveListApi = (params) => {
  return httpService({
    url: contextPath + '/spider/sensitive/word/search',
    method: 'get',
    params
  })
}

// 敏感词详情查询：
export const getSensitiveInfoApi = (params) => {
  return httpService({
    url: contextPath + '/spider/sensitive/word',
    method: 'get',
    params
  })
}
